import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InfoCardComponent } from '../../shared/components/info-card/info-card.component';
import { ActionCardComponent, ActionCardData } from '../../shared/components/action-card/action-card.component';

/**
 * WHY: Final contact page with flexible content projection and participation options
 * SOLID: Single responsibility - contact information and participation options
 */
@Component({
  selector: 'app-contact-final',
  templateUrl: './contact-final.html',
  imports: [CommonModule, RouterModule, InfoCardComponent, ActionCardComponent]
})
export class ContactFinalComponent {
  // WHY: Action cards data
  protected readonly actionCards = signal<ActionCardData[]>([
    {
      title: '',
      description: 'Eigentlich wolltet ihr euch zurückmelden?',
      buttonText: 'Hier geht\'s zur Antwort',
      routerLink: '/form'
    }
  ]);


}